module.exports = __webpack_public_path__ + "img/ring_y_l_0_1.8a0ad838.png";